import { updateExpression } from "babel-types";

const eltAttr = "data-js-forms-form-field-sum";
const selector = "[" + eltAttr + "]";
const formSumField = function (el, app) {

    const $el = $(el);
    const $input = $el.find("input");
    const srcFields = $el.attr("data-forms-form-field-sum-from").split(" ");
    const withinCurrentOnly = $el.attr("data-forms-form-field-sum-within-current-only") === "1";

    let $fields = $();
    const $container = withinCurrentOnly ? $el.closest(".Ge-Form-Set") : $("body");

    $.each(srcFields, (i, field) => {
        $fields = $fields.add( $container.find( "[data-forms-form-field-key='" + field + "']").find("input"));
    });

    const init = function () {
        registerEvents();
    };

    const registerEvents = function () {
        $el.closest("[data-js-forms-form-element]").on("displayRuleChange formSetDisplayChange", update);
        $fields.change(update);
        update()
    };

    const update = function () {
        let sum = 0;
        $.each($fields, function () {
            const $fieldInp = $(this);
            if ($fieldInp.is(":visible")) {
                const val = $.trim($fieldInp.val());
                if (val) {
                    sum += parseInt($fieldInp.val());
                }
            }
        });

        if (isNaN(sum)) {
            $input.val("-");
        }
        else {
            $input.val(sum);
        }
        $input.trigger("fieldLoaded");
    };

    return {
        init: init()
    };
};

formSumField.selector = selector;

export default formSumField;
